__turbopack_context__.v({
  "arc": "style-module-scss-module__ivhPOG__arc",
  "component": "style-module-scss-module__ivhPOG__component",
  "gauge": "style-module-scss-module__ivhPOG__gauge",
  "gaugeLabel": "style-module-scss-module__ivhPOG__gaugeLabel",
  "gaugeSubLabel": "style-module-scss-module__ivhPOG__gaugeSubLabel",
  "gaugeValue": "style-module-scss-module__ivhPOG__gaugeValue",
  "summary": "style-module-scss-module__ivhPOG__summary",
  "track": "style-module-scss-module__ivhPOG__track",
});
